import clsx from 'clsx'

/**
 * AppSkeleton — Atomic Skeleton Component with Premium Shimmer Animation
 *
 * Variants:
 *  - 'text': Single line of text with rounded ends (default)
 *  - 'circular': Circle, perfect for avatars and status dots
 *  - 'rectangular': Rounded card or block content
 *
 * @param {object} props
 * @param {'text'|'circular'|'rectangular'} [props.variant='text']
 * @param {string|number} [props.width]
 * @param {string|number} [props.height]
 * @param {string} [props.className]
 */
export function AppSkeleton({
  variant = 'text',
  width,
  height,
  className = '',
  style = {},
}) {
  return (
    <div
      className={clsx(
        'relative overflow-hidden bg-surface-container-low dark:bg-surface-container-high',
        'before:absolute before:inset-0 before:-translate-x-full before:animate-shimmer',
        'before:bg-gradient-to-r before:from-transparent before:via-white/40 dark:before:via-white/10 before:to-transparent',
        variant === 'text' && 'h-4 rounded',
        variant === 'circular' && 'rounded-full',
        variant === 'rectangular' && 'rounded-xl',
        className
      )}
      style={{ width, height, ...style }}
    />
  )
}

export default AppSkeleton
